import { render } from "./LabsByCapacity.vue?vue&type=template&id=420d7850"
import script from "./LabsByCapacity.vue?vue&type=script&lang=js"
export * from "./LabsByCapacity.vue?vue&type=script&lang=js"
script.render = render

export default script